export enum SectionIds {
    BALANCE = 'balance',
    INCOME = 'income',
    CASHFLOW = 'cashflow',
    NOTES = 'notes',
    AOP = 'AOP',
    EMS = 'Ems',
    FAS = 'Fas',
    COMPLEMENTARY_REPORT = 'complementaryReport',
    APBS = 'APBS',
    APIS = 'APIS',
    FINANCIAL_CLOSING_PROCESS = 'FCP',
    APPENDIX = 'APPENDIX',
}
